export const ES_CLIENTE = {
    Default:"¿Sos cliente?",
    Si:"Si",
    No:"No"
}